// Mock stop words data
// ⚠️ Упрощенная структура: action и notify_admin удалены
// ВСЯ логика обработки теперь определяется в Правилах маршрутизации (routing_rules)
export const mockStopWords = [
  {
    id: "sw-1",
    word: "суд",
    category: "legal",
    is_active: true,
    description: "Юридические угрозы - требует немедленной эскалации",
    created_at: "2025-10-15T10:00:00Z",
    updated_at: "2025-10-15T10:00:00Z",
  },
  {
    id: "sw-2",
    word: "прокуратура",
    category: "legal",
    is_active: true,
    description: "Обращение в надзорные органы",
    created_at: "2025-10-15T10:05:00Z",
    updated_at: "2025-10-15T10:05:00Z",
  },
  {
    id: "sw-3",
    word: "роспотребнадзор",
    category: "legal",
    is_active: true,
    description: "Обращение в Роспотребнадзор",
    created_at: "2025-10-15T10:10:00Z",
    updated_at: "2025-10-15T10:10:00Z",
  },
  {
    id: "sw-4",
    word: "полиция",
    category: "legal",
    is_active: true,
    description: "Обращение в правоохранительные органы",
    created_at: "2025-10-15T10:12:00Z",
    updated_at: "2025-10-15T10:12:00Z",
  },
  {
    id: "sw-5",
    word: "аллергия",
    category: "health",
    is_active: true,
    description: "Возможная аллергическая реакция",
    created_at: "2025-10-15T10:15:00Z",
    updated_at: "2025-10-15T10:15:00Z",
  },
  {
    id: "sw-6",
    word: "ожог",
    category: "health",
    is_active: true,
    description: "Химический или термический ожог",
    created_at: "2025-10-15T10:20:00Z",
    updated_at: "2025-10-15T10:20:00Z",
  },
  {
    id: "sw-7",
    word: "отравление",
    category: "health",
    is_active: true,
    description: "Серьезная проблема со здоровьем",
    created_at: "2025-10-15T10:25:00Z",
    updated_at: "2025-10-15T10:25:00Z",
  },
  {
    id: "sw-8",
    word: "сыпь",
    category: "health",
    is_active: true,
    description: "Кожная реакция",
    created_at: "2025-10-15T10:27:00Z",
    updated_at: "2025-10-15T10:27:00Z",
  },
  {
    id: "sw-9",
    word: "вред здоровью",
    category: "health",
    is_active: true,
    description: "Общее указание на вред здоровью",
    created_at: "2025-10-15T10:28:00Z",
    updated_at: "2025-10-15T10:28:00Z",
  },
  {
    id: "sw-10",
    word: "подделка",
    category: "quality",
    is_active: true,
    description: "Обвинение в контрафакте",
    created_at: "2025-10-15T10:30:00Z",
    updated_at: "2025-10-15T10:30:00Z",
  },
  {
    id: "sw-11",
    word: "контрафакт",
    category: "quality",
    is_active: true,
    description: "Обвинение в контрафакте",
    created_at: "2025-10-15T10:35:00Z",
    updated_at: "2025-10-15T10:35:00Z",
  },
  {
    id: "sw-12",
    word: "фальшивка",
    category: "quality",
    is_active: true,
    description: "Обвинение в поддельном товаре",
    created_at: "2025-10-15T10:37:00Z",
    updated_at: "2025-10-15T10:37:00Z",
  },
  {
    id: "sw-13",
    word: "обман",
    category: "fraud",
    is_active: true,
    description: "Обвинение в обмане покупателя",
    created_at: "2025-10-15T10:40:00Z",
    updated_at: "2025-10-15T10:40:00Z",
  },
  {
    id: "sw-14",
    word: "мошенники",
    category: "fraud",
    is_active: true,
    description: "Обвинение в мошенничестве",
    created_at: "2025-10-15T10:45:00Z",
    updated_at: "2025-10-15T10:45:00Z",
  },
  {
    id: "sw-15",
    word: "верну деньги через банк",
    category: "refund",
    is_active: true,
    description: "Угроза чарджбэка",
    created_at: "2025-10-15T10:50:00Z",
    updated_at: "2025-10-15T10:50:00Z",
  },
  {
    id: "sw-16",
    word: "чарджбэк",
    category: "refund",
    is_active: true,
    description: "Угроза возврата через банк",
    created_at: "2025-10-15T10:52:00Z",
    updated_at: "2025-10-15T10:52:00Z",
  },
  {
    id: "sw-17",
    word: "позор",
    category: "reputation",
    is_active: true,
    description: "Репутационный риск",
    created_at: "2025-10-15T10:55:00Z",
    updated_at: "2025-10-15T10:55:00Z",
  },
  {
    id: "sw-18",
    word: "в чёрный список",
    category: "reputation",
    is_active: true,
    description: "Угроза публичной дискредитации",
    created_at: "2025-10-15T10:57:00Z",
    updated_at: "2025-10-15T10:57:00Z",
  },
  {
    id: "sw-19",
    word: "испорчен",
    category: "quality",
    is_active: true,
    description: "Испорченный товар",
    created_at: "2025-10-15T11:20:00Z",
    updated_at: "2025-10-15T11:20:00Z",
  },
  {
    id: "sw-20",
    word: "срок годности истёк",
    category: "quality",
    is_active: true,
    description: "Проблемы со сроком годности",
    created_at: "2025-10-15T11:25:00Z",
    updated_at: "2025-10-15T11:25:00Z",
  },
];
